<script>
  import backend from "../../../../server";
  import { onMount } from "svelte";
  import { ICONS } from "../../../../js/icons";

  export let user = {};
  export let showModalNew;
  export let list;
  export let confirmSave;

  let isLoading = false;
  let showAlert = false;
  let message = '';
  let showPassword = false;
  let showConfirmPassword = false;

  let allClients = [];

  let mainMode = 'bo';
  let hasGestorBonosAccess = false;

  let selectedBoViews = [];
  let selectedReportingViews = [];
  let selectedGbViews = [];

  let reporteriaSelectedClients = [];
  let reporteriaClientSearch = "";

  let gbSelectedClients = [];
  let gbClientSearch = "";

  let wasOpen = false;
  let modalReady = false;

  $: usernamePreview = (user.username || '').replace(/ /g, '_').replace(/[^a-zA-Z0-9._-]/g, '');

  const BO_VIEWS = [
    { id: "games", label: "Juegos" },
    { id: "brands", label: "Marcas" },
    { id: "clients", label: "Clientes" },
    { id: "users", label: "Jugadores" },
    { id: "transactions", label: "Transacciones" },
    { id: "direct_trx", label: "Trans. Manuales" },
    { id: "bonus-management", label: "Gestor Bonos" },
    { id: "reports", label: "Reportería" },
  ];

  const REPORTING_VIEWS = [
    { id: "reports", label: "Reportería" },
    { id: "users_lite", label: "Jugadores (lite)" },
    { id: "transactions_lite", label: "Transacciones (lite)" },
  ];

  const GESTOR_BONOS_VIEWS = [
    { id: "amigo", label: "AmigoGaming" },
    { id: "first", label: "First" },
    { id: "firstV2", label: "First V2" },
    { id: "pragmatic", label: "Pragmatic" },
    { id: "clients", label: "Clientes" },
  ];

  $: if (showModalNew && !wasOpen) {
    wasOpen = true;
    loadUserData();
  }
  $: if (!showModalNew && wasOpen) {
    wasOpen = false;
  }

  $: reporteriaFilteredClients = reporteriaClientSearch
    ? allClients.filter(c => {
        const term = reporteriaClientSearch.toLowerCase();
        return (c.code || "").toLowerCase().includes(term) ||
               (c.namesite || c.businessname || "").toLowerCase().includes(term);
      })
    : allClients;

  $: gbFilteredClients = gbClientSearch
    ? allClients.filter(c => {
        const term = gbClientSearch.toLowerCase();
        return (c.code || "").toLowerCase().includes(term) ||
               (c.namesite || c.businessname || "").toLowerCase().includes(term);
      })
    : allClients;

  onMount(async () => {
    if (allClients.length === 0) await loadAllClients();
    if (!user.id) modalReady = true;
  });

  async function loadAllClients() {
    if (allClients.length > 0) return;
    try {
      const res = await backend.client.list({ xpage: 500, page: 1 });
      allClients = (res.data?.list || []).filter(c => c.code);
    } catch (e) {
      allClients = [];
    }
  }

  function clientName(code) {
    const c = allClients.find(x => x.code === code);
    return c ? (c.namesite || c.businessname || '') : '';
  }

  function toggleReporteriaClient(code, checked) {
    if (checked) {
      if (!reporteriaSelectedClients.includes(code)) reporteriaSelectedClients = [...reporteriaSelectedClients, code];
    } else {
      reporteriaSelectedClients = reporteriaSelectedClients.filter(c => c !== code);
    }
  }

  function removeReporteriaClient(code) {
    reporteriaSelectedClients = reporteriaSelectedClients.filter(c => c !== code);
  }

  function toggleGbClient(code, checked) {
    if (checked) {
      if (!gbSelectedClients.includes(code)) gbSelectedClients = [...gbSelectedClients, code];
    } else {
      gbSelectedClients = gbSelectedClients.filter(c => c !== code);
    }
  }

  function removeGbClient(code) {
    gbSelectedClients = gbSelectedClients.filter(c => c !== code);
  }

  function switchMode(mode) {
    if (mode === mainMode) return;
    mainMode = mode;
    selectedBoViews = [];
    selectedReportingViews = [];
    reporteriaSelectedClients = [];
    reporteriaClientSearch = "";
    if (mode === 'reporting') {
      hasGestorBonosAccess = false;
      selectedGbViews = [];
      gbSelectedClients = [];
      gbClientSearch = "";
    }
  }

  async function loadUserData() {
    if (allClients.length === 0) await loadAllClients();
    if (user.id) {
      try {
        const [boViewsRes, boClientsRes, amViewsRes, amClientsRes] = await Promise.all([
          backend.admins.getCredentials(`bo_views.${user.id}`),
          backend.admins.getCredentials(`bo_clients.${user.id}`),
          backend.admins.getCredentials(`am_views.${user.id}`),
          backend.admins.getCredentials(`am_clients.${user.id}`),
        ]);

        const boViewsRaw = boViewsRes.data?.[`bo_views.${user.id}`];
        if (boViewsRaw) {
          const parts = boViewsRaw.split(',').map(v => v.trim()).filter(Boolean);
          const hasReportingOnly = parts.some(v => ['users_lite', 'transactions_lite'].includes(v));

          if (hasReportingOnly) {
            mainMode = 'reporting';
            selectedReportingViews = parts.filter(v => REPORTING_VIEWS.some(rv => rv.id === v));
          } else if (parts.length > 0) {
            mainMode = 'bo';
            selectedBoViews = parts.filter(v => BO_VIEWS.some(bv => bv.id === v));
          }
        }

        const boClientsRaw = boClientsRes.data?.[`bo_clients.${user.id}`];
        if (boClientsRaw) {
          reporteriaSelectedClients = boClientsRaw.split(',').map(v => v.trim()).filter(Boolean);
        }

        const amViewsKey = `am_views.${user.id}`;
        const amClientsKey = `am_clients.${user.id}`;
        const amViewsRaw = amViewsRes.data?.[amViewsKey];
        const amClientsRaw = amClientsRes.data?.[amClientsKey];

        if (amViewsKey in (amViewsRes.data || {}) || amClientsKey in (amClientsRes.data || {})) {
          hasGestorBonosAccess = true;
        }
        if (amViewsRaw) {
          selectedGbViews = amViewsRaw.split(',').map(v => v.trim()).filter(Boolean);
        }
        if (amClientsRaw) {
          gbSelectedClients = amClientsRaw.split(',').map(v => v.trim()).filter(Boolean);
        }
      } catch (e) {}
    }
    modalReady = true;
  }

  function toggleView(arr, viewId) {
    if (arr.includes(viewId)) {
      return arr.filter(v => v !== viewId);
    }
    return [...arr, viewId];
  }

  async function save() {
    const cleanUsername = usernamePreview;
    if (!user.firstname) return showError('Es obligatorio el nombre');
    if (!cleanUsername) return showError('Es obligatorio el usuario');
    if (!user.id) {
      if (!user.pass) return showError('Es obligatorio la contraseña');
      if (!user.confirmPassword) return showError('Es obligatorio confirmar la contraseña');
      if (user.confirmPassword !== user.pass) return showError('Las contraseñas deben ser iguales');
    }

    try {
      isLoading = true;
      const payload = {
        firstname: user.firstname,
        username: cleanUsername,
        role: 10,
        status: user.status ?? 1,
        country: "PE",
        currency: "PEN",
        lastname: "",
        address: "ADMIN_BO",
      };
      if (user.id) payload.id = user.id;
      if (user.pass) payload.pass = user.pass;

      const result = await backend.admins.save(payload);
      if (result.data?.status == 200) {
        const userId = result.data?.id || user.id;

        if (mainMode === 'bo') {
          if (selectedBoViews.length > 0) {
            await backend.admins.saveCredential({ key: `bo_views.${userId}`, value: selectedBoViews.join(',') });
          } else {
            try { await backend.admins.removeCredential(`bo_views.${userId}`); } catch {}
          }
          try { await backend.admins.removeCredential(`bo_clients.${userId}`); } catch {}

          if (hasGestorBonosAccess) {
            await backend.admins.saveCredential({ key: `am_views.${userId}`, value: selectedGbViews.join(',') || '' });
            await backend.admins.saveCredential({ key: `am_clients.${userId}`, value: gbSelectedClients.join(',') || '' });
          } else {
            try { await backend.admins.removeCredential(`am_views.${userId}`); } catch {}
            try { await backend.admins.removeCredential(`am_clients.${userId}`); } catch {}
          }
        } else {
          if (selectedReportingViews.length > 0) {
            await backend.admins.saveCredential({ key: `bo_views.${userId}`, value: selectedReportingViews.join(',') });
          } else {
            try { await backend.admins.removeCredential(`bo_views.${userId}`); } catch {}
          }

          if (reporteriaSelectedClients.length > 0) {
            await backend.admins.saveCredential({ key: `bo_clients.${userId}`, value: reporteriaSelectedClients.join(',') });
          } else {
            try { await backend.admins.removeCredential(`bo_clients.${userId}`); } catch {}
          }

          try { await backend.admins.removeCredential(`am_views.${userId}`); } catch {}
          try { await backend.admins.removeCredential(`am_clients.${userId}`); } catch {}
        }

        showModalNew = false;
        confirmSave && confirmSave();
        list && list();
      } else {
        showError(result.data?.message || 'No se completó el registro');
      }
    } catch (error) {
      const msg = error?.response?.data?.message || '';
      showError(msg === 'USERNAME_ALREADY_EXISTS' ? 'El nombre de usuario ya existe, elige otro' : (msg || "No se puede crear el usuario"));
    } finally {
      isLoading = false;
    }
  }

  const cancelar = () => (showModalNew = false);

  const showError = (msg) => {
    message = msg;
    showAlert = true;
    setTimeout(() => { showAlert = false; }, 3000);
  };
</script>

{#if showModalNew}
  <div class="modal-backdrop" on:click={cancelar}></div>
  <div class="modal-form">
    <h5 class="modal-title">{user.id ? 'Editar' : 'Nuevo'} Administrador</h5>

    {#if !modalReady}
      <div class="text-center py-4">
        <span class="spinner-border spinner-border-sm me-1"></span>
        Cargando opciones...
      </div>
    {:else}
      {#if showAlert}
        <div class="alert alert-danger py-1 px-2 mb-2 small">
          <strong>Error:</strong> {message}
        </div>
      {/if}

    <div class="compact-field-row">
      <div class="compact-field flex-grow">
        <label class="c-label">Nombres</label>
        <input type="text" class="form-control form-control-sm" placeholder="Nombres" bind:value={user.firstname} />
      </div>
      <div class="compact-field w-auto">
        <label class="c-label">Estado</label>
        <label class="toggle-pill" class:active={user.status === 1}>
          <input type="checkbox" checked={user.status === 1} on:change={(e) => user.status = e.target.checked ? 1 : 0} />
          <span class="toggle-text">{user.status === 1 ? 'Activo' : 'Inactivo'}</span>
        </label>
      </div>
    </div>

    <div class="compact-field">
      <label class="c-label">Usuario</label>
      <input type="text" class="form-control form-control-sm" placeholder="Usuario" bind:value={user.username} disabled={!!user.id} />
      <div class="preview mt-1">
        {#if usernamePreview}
          <span class="badge badge-preview">{usernamePreview}</span>
        {:else}
          <span class="text-muted small">Vista previa del usuario</span>
        {/if}
      </div>
    </div>

    {#if !user.id}
      <div class="compact-field-row">
        <div class="compact-field flex-grow">
          <label class="c-label">Contraseña</label>
          <div class="input-group input-group-sm">
            {#if showPassword}
              <input class="form-control" type="text" bind:value={user.pass} on:input={(e) => user.pass = e.target.value.replace(/\s/g, '')} on:keydown={(e) => e.key === ' ' && e.preventDefault()} placeholder="••••••" />
            {:else}
              <input class="form-control" type="password" bind:value={user.pass} on:input={(e) => user.pass = e.target.value.replace(/\s/g, '')} on:keydown={(e) => e.key === ' ' && e.preventDefault()} placeholder="••••••" />
            {/if}
            <button class="btn btn-outline-secondary" type="button" on:click={() => showPassword = !showPassword}>
              <i class="fa-solid {showPassword ? 'fa-eye-slash' : 'fa-eye'}"></i>
            </button>
          </div>
        </div>
        <div class="compact-field flex-grow">
          <label class="c-label">Confirmar</label>
          <div class="input-group input-group-sm">
            {#if showConfirmPassword}
              <input class="form-control" type="text" bind:value={user.confirmPassword} on:input={(e) => user.confirmPassword = e.target.value.replace(/\s/g, '')} on:keydown={(e) => e.key === ' ' && e.preventDefault()} placeholder="••••••" />
            {:else}
              <input class="form-control" type="password" bind:value={user.confirmPassword} on:input={(e) => user.confirmPassword = e.target.value.replace(/\s/g, '')} on:keydown={(e) => e.key === ' ' && e.preventDefault()} placeholder="••••••" />
            {/if}
            <button class="btn btn-outline-secondary" type="button" on:click={() => showConfirmPassword = !showConfirmPassword}>
              <i class="fa-solid {showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}"></i>
            </button>
          </div>
        </div>
      </div>
    {/if}

    <div class="mode-tabs">
      <button class="mode-tab" class:active={mainMode === 'bo'} on:click={() => switchMode('bo')}>
        <span class="mode-tab-icon">⚙️</span>
        Backoffice
      </button>
      <button class="mode-tab" class:active={mainMode === 'reporting'} on:click={() => switchMode('reporting')}>
        <span class="mode-tab-icon">📊</span>
        Reportería
      </button>
    </div>

    {#if mainMode === 'bo'}
      <div class="module-card">
        <div class="module-header">
          <div class="module-title-area">
            <span class="module-badge module-badge-bo">Backoffice</span>
            <span class="module-desc">Acceso al panel de administración con acceso a TODOS los clientes</span>
          </div>
        </div>
        <div class="module-body">
          <div class="pills-wrap">
            {#each BO_VIEWS as v}
              <label class="pill-btn" class:active={selectedBoViews.includes(v.id)}>
                <input type="checkbox" checked={selectedBoViews.includes(v.id)} on:change={() => selectedBoViews = toggleView(selectedBoViews, v.id)} />
                <span>{v.label}</span>
              </label>
            {/each}
          </div>
        </div>
      </div>

      <div class="module-card">
        <div class="module-header">
          <div class="module-title-area">
            <span class="module-badge module-badge-gb">Gestor Bonos</span>
            <span class="module-desc">Panel de bonos</span>
          </div>
          <label class="switch" on:click={(e) => e.stopPropagation()}>
            <input type="checkbox" bind:checked={hasGestorBonosAccess} />
            <span class="slider"></span>
          </label>
        </div>
        {#if hasGestorBonosAccess}
          <div class="module-body">
            <div class="pills-wrap mb-1">
              {#each GESTOR_BONOS_VIEWS as v}
                <label class="pill-btn" class:active={selectedGbViews.includes(v.id)}>
                  <input type="checkbox" checked={selectedGbViews.includes(v.id)} on:change={() => selectedGbViews = toggleView(selectedGbViews, v.id)} />
                  <span>{v.label}</span>
                </label>
              {/each}
            </div>
            <div class="module-clients-section">
              <label class="c-label">Clientes <span class="text-muted small">(opcional)</span></label>
              <div class="chips-compact mb-1">
                {#each gbSelectedClients as code}
                  <span class="chip-sm">
                    <span class="chip-sm-code">{code}</span>
                    <span class="chip-sm-name">{clientName(code)}</span>
                    <button class="chip-sm-remove" on:click={() => removeGbClient(code)}>&times;</button>
                  </span>
                {:else}
                  <span class="text-muted small">Ninguno</span>
                {/each}
              </div>
              <input class="form-control form-control-sm mb-1" bind:value={gbClientSearch} placeholder="Buscar cliente..." />
              <div class="client-list-sm">
                {#each gbFilteredClients as c}
                  <label class="client-item-sm">
                    <input type="checkbox" checked={gbSelectedClients.includes(c.code)} on:change={(e) => toggleGbClient(c.code, e.target.checked)} />
                    <span class="cli-code">{c.code}</span>
                    <span class="cli-name">{c.namesite || c.businessname || c.code}</span>
                  </label>
                {:else}
                  <span class="text-muted small px-1">Sin resultados</span>
                {/each}
              </div>
            </div>
          </div>
        {/if}
      </div>
    {:else}
      <div class="module-card">
        <div class="module-header">
          <div class="module-title-area">
            <span class="module-badge module-badge-rep">Reportería</span>
            <span class="module-desc">Reportes y consultas lite</span>
          </div>
        </div>
        <div class="module-body">
          <div class="pills-wrap mb-1">
            {#each REPORTING_VIEWS as v}
              <label class="pill-btn" class:active={selectedReportingViews.includes(v.id)}>
                <input type="checkbox" checked={selectedReportingViews.includes(v.id)} on:change={() => selectedReportingViews = toggleView(selectedReportingViews, v.id)} />
                <span>{v.label}</span>
              </label>
            {/each}
          </div>
          <div class="module-clients-section">
            <label class="c-label">Clientes <span class="text-muted small">(opcional — sin selección ve todos)</span></label>
            <div class="chips-compact mb-1">
              {#each reporteriaSelectedClients as code}
                <span class="chip-sm">
                  <span class="chip-sm-code">{code}</span>
                  <span class="chip-sm-name">{clientName(code)}</span>
                  <button class="chip-sm-remove" on:click={() => removeReporteriaClient(code)}>&times;</button>
                </span>
              {:else}
                <span class="text-muted small">Ninguno</span>
              {/each}
            </div>
            <input class="form-control form-control-sm mb-1" bind:value={reporteriaClientSearch} placeholder="Buscar cliente..." />
            <div class="client-list-sm">
              {#each reporteriaFilteredClients as c}
                <label class="client-item-sm">
                  <input type="checkbox" checked={reporteriaSelectedClients.includes(c.code)} on:change={(e) => toggleReporteriaClient(c.code, e.target.checked)} />
                  <span class="cli-code">{c.code}</span>
                  <span class="cli-name">{c.namesite || c.businessname || c.code}</span>
                </label>
              {:else}
                <span class="text-muted small px-1">Sin resultados</span>
              {/each}
            </div>
          </div>
        </div>
      </div>
    {/if}

    <div class="modal-footer-actions">
      <button class="btn btn-primary btn-sm" on:click={save} disabled={isLoading}>
        {#if isLoading}
          <span class="spinner-border spinner-border-sm"></span>
        {/if}
        Guardar
      </button>
      <button class="btn btn-secondary btn-sm" on:click={cancelar}>Cancelar</button>
    </div>
    {/if}
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    top: 0; left: 0; width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.4);
    z-index: 1040;
  }
  .modal-form {
    position: fixed;
    top: 50%; left: 50%; transform: translate(-50%, -50%);
    background: #fff;
    padding: 1rem 1.25rem;
    border-radius: 0.5rem;
    z-index: 1050;
    min-width: 360px;
    max-width: 92vw;
    width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  }
  .modal-title {
    margin: 0 0 0.6rem;
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.4rem;
  }

  .mode-tabs {
    display: flex;
    gap: 0.25rem;
    margin-bottom: 0.6rem;
    background: #f0f1f3;
    border-radius: 0.5rem;
    padding: 0.2rem;
  }
  .mode-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    padding: 0.45rem 0.5rem;
    border: none;
    border-radius: 0.4rem;
    background: transparent;
    font-size: 0.82rem;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  .mode-tab.active {
    background: #fff;
    color: #222;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  }
  .mode-tab:not(.active):hover {
    color: #333;
  }
  .mode-tab-icon {
    font-size: 1rem;
  }

  .c-label {
    font-weight: 600;
    font-size: 0.78rem;
    margin-bottom: 0.2rem;
    color: #333;
    display: block;
  }
  .compact-field {
    margin-bottom: 0.5rem;
  }
  .compact-field-row {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .compact-field-row .compact-field {
    margin-bottom: 0;
  }
  .flex-grow { flex: 1; }
  .w-auto { width: auto; }

  .module-card {
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    margin-bottom: 0.6rem;
    background: #fff;
    overflow: hidden;
    transition: box-shadow 0.15s ease;
  }
  .module-card:hover {
    box-shadow: 0 1px 6px rgba(0,0,0,0.06);
  }
  .module-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.55rem 0.7rem;
    background: #f7f8fa;
    border-bottom: 1px solid #e8e8e8;
  }
  .module-title-area {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
  }
  .module-badge {
    font-weight: 700;
    font-size: 0.82rem;
    letter-spacing: 0.01em;
  }
  .module-badge-bo { color: #0d6efd; }
  .module-badge-rep { color: #0f973d; }
  .module-badge-gb { color: #e8590c; }
  .module-desc {
    font-size: 0.72rem;
    color: #888;
  }
  .module-body {
    padding: 0.55rem 0.7rem;
  }
  .module-clients-section {
    border-top: 1px dashed #e0e0e0;
    padding-top: 0.4rem;
    margin-top: 0.25rem;
  }

  .pills-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  .pill-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    border: 1px solid #ced4da;
    border-radius: 0.3rem;
    padding: 0.2rem 0.5rem;
    font-size: 0.78rem;
    cursor: pointer;
    background: #f8f9fa;
    color: #495057;
    transition: all 0.12s ease;
    user-select: none;
  }
  .pill-btn input { display: none; }
  .pill-btn.active {
    background: #FF0090;
    border-color: #FF0090;
    color: #fff;
  }
  .pill-btn:hover {
    border-color: #FF0090;
    color: #FF0090;
  }
  .pill-btn.active:hover { color: #fff; }

  .toggle-pill {
    display: inline-flex;
    align-items: center;
    border-radius: 1rem;
    padding: 0.2rem 0.7rem;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
    transition: all 0.15s ease;
    border: 1px solid #ced4da;
  }
  .toggle-pill input { display: none; }
  .toggle-pill.active {
    background: #d1fae5;
    color: #065f46;
    border-color: #a7f3d0;
  }
  .toggle-pill:not(.active) {
    background: #fee2e2;
    color: #991b1b;
    border-color: #fecaca;
  }
  .toggle-text { line-height: 1.4; }

  .chips-compact {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    max-height: 80px;
    overflow-y: auto;
  }
  .chip-sm {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 0.25rem;
    padding: 0.15rem 0.4rem;
    font-size: 0.75rem;
  }
  .chip-sm-code { font-weight: 600; color: #0d6efd; }
  .chip-sm-name {
    color: #6c757d;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chip-sm-remove {
    background: none;
    border: none;
    font-size: 1rem;
    line-height: 1;
    padding: 0 0 0 0.15rem;
    cursor: pointer;
    color: #dc3545;
  }
  .chip-sm-remove:hover { color: #a71d2a; }

  .client-list-sm {
    max-height: 120px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-radius: 0.3rem;
    padding: 0.2rem;
    background: #fff;
  }
  .client-item-sm {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.2rem 0.35rem;
    border-radius: 0.2rem;
    cursor: pointer;
    font-size: 0.78rem;
  }
  .client-item-sm:hover { background: #f8f9fa; }
  .client-item-sm input[type="checkbox"] { margin: 0; flex-shrink: 0; }
  .cli-code { font-weight: 600; color: #0d6efd; min-width: 40px; font-size: 0.75rem; }
  .cli-name {
    color: #495057;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    font-size: 0.75rem;
  }

  .preview { min-height: 1.25rem; }
  .badge-preview {
    background: #FF0090;
    color: #fff;
    padding: 0.15rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.78rem;
    font-family: monospace;
    font-weight: 600;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
    flex-shrink: 0;
  }
  .switch input { display: none; }
  .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background: #adb5bd;
    border-radius: 20px;
    transition: 0.2s;
  }
  .slider::before {
    content: '';
    position: absolute;
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background: #fff;
    border-radius: 50%;
    transition: 0.2s;
  }
  .switch input:checked + .slider { background: #198754; }
  .switch input:checked + .slider::before { transform: translateX(16px); }
  .switch input:disabled + .slider {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .modal-footer-actions {
    display: flex;
    gap: 0.4rem;
    justify-content: flex-end;
    border-top: 1px solid #eee;
    padding-top: 0.6rem;
    margin-top: 0.25rem;
  }
</style>
